var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "insta tiendaAsset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.08,242.19H364.92A122.9,122.9,0,0,0,242.19,364.92V635.08A122.9,122.9,0,0,0,364.92,757.81H635.08A122.9,122.9,0,0,0,757.81,635.08V364.92A122.9,122.9,0,0,0,635.08,242.19ZM500,660.55c-88.52,0-160.55-72-160.55-160.55s72-160.55,160.55-160.55,160.55,72,160.55,160.55S588.52,660.55,500,660.55ZM664.92,372.27a37.52,37.52,0,1,1,37.54-37.54A37.52,37.52,0,0,1,664.92,372.27ZM500,394.14A105.86,105.86,0,1,0,605.86,500,106,106,0,0,0,500,394.14ZM500,0C223.87,0,0,223.87,0,500s223.87,500,500,500,500-223.87,500-500S776.13,0,500,0ZM812.5,635.08c0,97.81-79.61,177.42-177.42,177.42H364.92c-97.81,0-177.42-79.61-177.42-177.42V364.92c0-97.81,79.61-177.42,177.42-177.42H635.08c97.81,0,177.42,79.61,177.42,177.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagram-white.1d6593b4ed682497b6526f1adcf0efc1.svg";
export { ForwardRef as ReactComponent };